import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError, of } from 'rxjs';
import { UrlSignature } from '../common/apiEndPoint';
import { catchError, tap } from 'rxjs/operators';
import countriesData from './countrynstates.json';

@Injectable({
  providedIn: 'root',
})

export class ApplicantdashboardserviceService {
  constructor(private http: HttpClient, private urlSignature: UrlSignature) {}

getCountriesAndStates(): Observable<any> {
  return of(countriesData);
}

  ProgrammeList(): Observable<any> {
    return this.http.get<any>(this.urlSignature.programmeTypesUrl);
  }

  getApplicantData(token: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get<any>(this.urlSignature.applicantdashboardinitialinformationurl, { headers });
  }

  getApplicantStatus(token: string): Observable<any> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    return this.http.get<any>(this.urlSignature.applicationstatusurl, {
      headers,
    });
  }

  saveorupdateApplicant(applicantData: any, token: string): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    });
    return this.http.post<any>(this.urlSignature.saveandupdateapplicantinfourl, applicantData, { headers });
  }

  uploadDocument(file: File, documentType: string, token: string): Observable<any> {
    if (!file) {
      return throwError(() => new Error('No file provided'));
    }

    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });

    const formData = new FormData();
    formData.append('file', file);
    formData.append('documentType', documentType);

    const uploadUrl = `${this.urlSignature.uploaddocumenturl}`;

    return this.http.post<any>(uploadUrl, formData, { headers }).pipe(
      tap((response) => console.log('Upload response:', response)),
      catchError((error) => {
        console.error('Upload error:', error);
        return throwError(() => error);
      })
    );
  }


  retrieveDocuments(token: string): Observable<{ success: boolean; documents: { [key: string]: string } }> {
    const headers = new HttpHeaders({
      Authorization: `Bearer ${token}`,
    });
    return this.http
      .get<{ success: boolean; documents: { [key: string]: string } }>(this.urlSignature.retrievedocumenturl, {
        headers,
      })
      .pipe(
        tap((response) => console.log('Retrieved documents:', response)),
        catchError((error) => {
          console.error('Failed to retrieve documents', error);
          return throwError(() => error);
        })
      );
  }
}
